import { render } from "./AdminList.vue?vue&type=template&id=2119fc04"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"

import "./AdminList.vue?vue&type=style&index=0&id=2119fc04&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__